import {PAY_M, PC_PAY} from '@web/core/urls'
import {GwError} from '@web/helpers/api'
import authCreator from '@web/middlewares/auth'
import {orderInterrupted} from '@web/middlewares/orderInterrupted'

import {RootState} from '../../interfaces'

/**
 * 정기결제 APP 내의 API 요청 시 권한오류가 발생하는 케이스를 관리합니다.
 */
const auth = authCreator<RootState>({
    transactionStopHandler: ({next, action, isMobileDisplay}) => {
        const error = JSON.parse(action.error.message) as GwError
        const {
            data: {message: reason},
        } = error

        const redirectUrl = isMobileDisplay ? `${PAY_M}/mobile/memberStop` : `${PC_PAY}/memberStopPopup`
        return next(
            orderInterrupted([
                {
                    type: 'REDIRECT',
                    url: redirectUrl,
                    reason,
                },
            ]),
        )
    },
})

/** 페이 회원 인증 미들웨어  */
export default auth
